export default __webpack_public_path__ + "static/media/p.434317e5.png";